import { render, staticRenderFns } from "./ListForFinalApprovals.vue?vue&type=template&id=70ace0ec&"
import script from "./ListForFinalApprovals.vue?vue&type=script&lang=js&"
export * from "./ListForFinalApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports